export enum LinkCreateStatus {
  Initial = 'initial',
  Edit = 'Edit',
  Unarchive = 'unarchive',
  GeneratingLink = 'generating link',
  ErrorGeneratingLink = 'error generating link',
  ErrorEditingLink = 'error editing link',
  Error = 'error',
  CompletedWithWarnings = 'completed with warnings',
  Completed = 'completed',
}
